import IndustryLandingTemplate, { IndustryPageData } from '@/components/industry/IndustryLandingTemplate';

const realEstateData: IndustryPageData = {
  slug: 'real-estate',
  name: 'Real Estate',
  heroHeadline: 'Build Trust with Verified Client Reviews for Your Real Estate Business',
  heroSubheadline: 'Help homebuyers and property investors find you through authentic Google reviews that highlight your expertise and successful deals.',
  painPoint: '92% of property buyers read online reviews before contacting a real estate agent',
  trustProblem: 'In a high-value industry like real estate, trust is everything—yet most agents have fewer than 20 reviews.',
  challenges: [
    {
      title: 'High-Stakes Trust Deficit',
      description: 'Real estate involves life savings. Buyers hesitate to work with agents who lack social proof and verified reviews.',
    },
    {
      title: 'Low Review Collection Rate',
      description: 'The long buying cycle (3-6 months) means clients forget to leave reviews by the time deals close.',
    },
    {
      title: 'Missing Location Keywords',
      description: 'Reviews don\'t mention property types, localities, or city names that potential clients search for.',
    },
    {
      title: 'Competitive Local Market',
      description: 'Other agents with more reviews and better ratings dominate local search results.',
    },
  ],
  useCases: [
    {
      category: 'Property Buying',
      description: 'Reviews from happy homebuyers highlighting your guidance and expertise.',
      keywords: ['best real estate agent', 'property advisor', 'home buying help'],
    },
    {
      category: 'Property Selling',
      description: 'Reviews from sellers who got great deals with your help.',
      keywords: ['sold my property fast', 'best price for flat', 'property dealer'],
    },
    {
      category: 'Rental Services',
      description: 'Reviews from tenants and landlords for rental assistance.',
      keywords: ['rental agent', 'flat for rent help', 'PG accommodation'],
    },
  ],
  caseStudy: {
    businessType: 'Real Estate Agency',
    city: 'Noida',
    challenges: [
      'Only 15 Google reviews despite 200+ successful deals',
      'Not appearing in "property dealer in Noida" searches',
      'Losing clients to competitors with more reviews',
    ],
    solution: 'Implemented Review Plum with categories for Buying, Selling, and Commercial Properties. Created locality-specific templates for Noida sectors and Gurgaon areas.',
    results: [
      { metric: 'Google Reviews', value: '15 → 89' },
      { metric: 'Google Rating', value: '4.0 → 4.7' },
      { metric: 'Organic Leads', value: '+85%' },
      { metric: 'Trust Conversions', value: '+45%' },
    ],
  },
  sampleReviews: [
    {
      category: 'Property Buying',
      reviews: [
        {
          text: 'Excellent experience buying our first home in Noida Sector 150! The team was patient throughout the 4-month process and helped us negotiate a great deal. They understood our budget and showed us properties that matched our requirements. Best real estate agent in Noida for first-time buyers.',
          keywords: ['real estate agent in Noida', 'first home', 'Sector 150'],
        },
        {
          text: 'After struggling with multiple property dealers, we finally found professionals who genuinely cared. They helped us find a 3BHK in Greater Noida West within our budget. Transparent dealing, no hidden commissions. Highly recommend for anyone looking to buy property in NCR.',
          keywords: ['property dealers', '3BHK Greater Noida', 'buy property in NCR'],
        },
      ],
    },
    {
      category: 'Commercial',
      reviews: [
        {
          text: 'Found the perfect office space for my startup with their help! They understood our requirements for a co-working friendly location in Cyber City. Negotiated a great deal on rent. Best commercial property dealer in Gurgaon.',
          keywords: ['office space Cyber City', 'commercial property Gurgaon', 'startup office'],
        },
        {
          text: 'Helped us secure a shop in a prime location at Saket. The team has great knowledge of commercial real estate and rental yields. Transparent process with no hidden charges. Highly recommend for retail space in South Delhi.',
          keywords: ['shop Saket', 'retail space South Delhi', 'commercial real estate'],
        },
      ],
    },
    {
      category: 'Rentals',
      reviews: [
        {
          text: 'Found a beautiful 2BHK on rent within my budget in Sector 62! The agent showed multiple options and was patient with my requirements. No brokerage issues and smooth documentation. Best rental agent in Noida.',
          keywords: ['2BHK rent Sector 62', 'rental agent Noida', 'flat on rent'],
        },
        {
          text: 'As a landlord, I was struggling to find good tenants. This agency verified tenants properly and found reliable people within a week. Professional service for both landlords and tenants. Top property rental service in NCR.',
          keywords: ['tenant verification', 'property rental NCR', 'landlord service'],
        },
      ],
    },
  ],
  cityKeywords: [
    'real estate agent Mumbai',
    'property dealer Delhi',
    'flat for sale Bengaluru',
    'builder Noida',
    'property consultant Gurgaon',
    'real estate Hyderabad',
  ],
  nearMeKeywords: [
    'property dealer near me',
    'real estate agent near me',
    'flat for sale near me',
    'property consultant nearby',
    'best broker near me',
    'house for sale close by',
  ],
  ctaText: 'Get More Client Reviews',
};

export default function RealEstatePage() {
  return <IndustryLandingTemplate data={realEstateData} />;
}
